import { render, staticRenderFns } from "./shipped-order-detail.vue?vue&type=template&id=8bb3e4bc&"
import script from "./shipped-order-detail.vue?vue&type=script&lang=js&"
export * from "./shipped-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports